import React from 'react';
import { CoffeeHero } from '../components/coffee/CoffeeHero';
import { CoffeeStats } from '../components/coffee/CoffeeStats';
import { CoffeeJourney } from '../components/coffee/CoffeeJourney';
import { CoffeeFeatures } from '../components/coffee/CoffeeFeatures';
import { CoffeeRegulation } from '../components/coffee/CoffeeRegulation';
import { CoffeeCTA } from '../components/coffee/CoffeeCTA';
import { Footer } from '../components/Footer';
export function CoffeeTraceability() {
  return <>
      <CoffeeHero data-id="element-961" />
      <CoffeeStats data-id="element-962" />
      <CoffeeJourney data-id="element-963" />
      <CoffeeFeatures data-id="element-964" />
      <CoffeeRegulation data-id="element-965" />
      <CoffeeCTA data-id="element-966" />
      <Footer data-id="element-967" />
    </>;
}